import React from "react";
import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { IconButton, CircularProgress, Tooltip } from "@mui/material";
import { Golf as AutoSoundShapingIcon } from "mdi-material-ui";

import OrderSidebar from "../index";

let circularDep = null;
const getAutoSoundShapingMutation = () => {
  if (circularDep == null) {
    circularDep = gql`
      mutation ($orderId: ID!, $cartItemId: ID!) {
        AutoSoundShaping(orderId: $orderId, cartItemId: $cartItemId) {
          order {
            id

            ...OrderSidebar_order
          }
        }
      }

      ${OrderSidebar.fragments.order}
    `;
  }

  return circularDep;
};

export default function AutoSoundShaping({ orderId, cartItem }) {
  const [mutate, { loading }] = useMutation(getAutoSoundShapingMutation());

  if (!cartItem.autoSoundShapingAvailable) return null;

  return (
    <Tooltip placement="top" title="Sound shaping automatique">
      <span>
        <IconButton
          size="small"
          disabled={loading}
          onClick={() =>
            mutate({ variables: { orderId, cartItemId: cartItem.id } })
          }
        >
          {loading ? <CircularProgress size="1em" /> : <AutoSoundShapingIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}

AutoSoundShaping.fragments = {
  cartItem: gql`
    fragment OrderSidebar_SoundShaping_AutoSoundShaping_cartItem on CartItem {
      id
      autoSoundShapingAvailable
    }
  `,
};
